<template>
  <div class="my-3">
    <div class="font-medium font-weight-bold">
      Associated Media Links
    </div>

    <BaseLoader v-if="!media" />

    <template v-if="!!media">
      <v-chip
        class="mt-2 ml-2 clickable"
        @click="openDialog()"
      >
        Add Associated Media Links

        <v-avatar right>
          <v-icon>mdi-plus</v-icon>
        </v-avatar>
      </v-chip>

      <div class="mt-6">
        <draggable
          v-model="mediaClone"
          handel=".handle"
          v-bind="dragOptions"
          :options="{ disabled: isLoading }"
          @change="onReorder()"
        >
          <transition-group>
            <div
              v-for="m in mediaClone"
              :key="m.id"
              class="media"
            >
              <div
                class="handle"
                style="height: 100%; width: 100%"
              >
                <v-icon>mdi-drag-horizontal-variant</v-icon>
              </div>
              <button
                :aria-label="'Edit Associated Media'"
                :disabled="m.id === -1"
                class="btn"
                @click="onEdit(m)"
              >
                <!-- <img
                  style="width: 62px; height: 62px;"
                  :src="m.imageFileUrl | filePath"
                > -->
                <div>
                  <ReadonlyQuill
                    style="margin-left: -15px;"
                    :value="m.title"
                  />

                  <!-- , <span style="font-style: italic">{{ m.subtitle }}</span> -->

                  <ReadonlyQuill
                    style="margin-left: -15px;"
                    :value="m.shortDescription"
                  />
                </div>
              </button>

              <button
                class="end"
                :aria-label="'delete media ' + m.title"
                :disabled="m.id === -1"
                @click="deleteMedia(m)"
              >
                <v-icon>mdi-close</v-icon>
              </button>

              <div class="loading-indicator">
                <base-loader v-if="m.id === -1" />
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </template>

    <template v-if="isDialogOpen">
      <v-dialog v-model="isDialogOpen" persistent>
        <v-card>
          <v-form ref="form">
            <v-card-title
              class="bpg-card-title-block d-flex justify-space-between"
            >
              <div class="font-weight-extra">
                Add Associated Media Links
              </div>
              <v-btn
                icon
                aria-label="close"
                @click="closeDialog()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <div class="pa-6 font-default-size">
              <!-- <div class="field">
                <span class="font-medium font-weight-bold">Display Image</span>
                <FileDrop
                  v-if="
                    !editingMedia ||
                      (editingMedia && !editingMedia.imageFileUrl)
                  "
                  :value="newMedia.imageFile ? newMedia.imageFile.name : ''"
                  accept="image/png, image/gif, image/jpeg"
                  class="mt-6"
                  @input="onImageFileChange($event)"
                  @clear="newMedia.imageFile = null"
                >
                  <div>
                    <span class="font-weight-bold primary--text"> Browse</span><span> or drop your image file here.</span>
                  </div>
                </FileDrop>

                <div
                  v-else
                  class="d-flex align-center mt-6"
                >
                  <div class="editing-box">
                    {{ editingMedia.imageFileUrl }}
                  </div>
                  <v-btn
                    text
                    @click="editingMedia.imageFileUrl = null"
                  >
                    <v-icon class="close-button clickable ml-2">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
              </div> -->

              <div class="field">
                <span class="font-medium font-weight-bold">Type/tags (comma separate multiples)</span>
                <v-text-field
                  v-model="newMedia.tags"
                  outlined
                  aria-label="Tags"
                  :rules="required"
                  class="base-input v-text-no-shadow v-input-restrict-height"
                />
              </div>

              <div class="field">
                <span class="font-medium font-weight-bold">Title *</span>
                <quill-editor
                  v-model="newMedia.title"
                  aria-label="Title"
                  required
                  :options="editorOption"
                />
              </div>

              <!-- <div class="field">
                <span class="font-medium font-weight-bold">Subtitle</span>
                <v-text-field
                  v-model="newMedia.subtitle"
                  outlined
                  aria-label="Subtitle"
                  :rules="required"
                  class="base-input v-text-no-shadow v-input-restrict-height"
                />
              </div> -->

              <div class="field">
                <span
                  class="font-medium font-weight-bold"
                >Short Description</span>
                <quill-editor
                  v-model="newMedia.shortDescription"
                  aria-label="Short Description"
                  :options="editorOption"
                />
              </div>

              <div class="field">
                <span class="font-medium font-weight-bold">Call to Action</span>
                <quill-editor
                  v-model="newMedia.callToAction"
                  aria-label="call to action"
                  :options="editorOption"
                />
              </div>

              <div class="field">
                <span class="font-medium font-weight-bold">Link</span>
                <v-radio-group
                  :value="linkType"
                  row
                  @change="onChangeLinkType($event)"
                >
                  <v-radio
                    value="url"
                    label="URL"
                  />
                  <v-radio
                    value="upload"
                    label="File (PDF)"
                  />
                </v-radio-group>

                <div
                  v-if="linkType === 'url'"
                  class="mt-6"
                >
                  <v-text-field
                    v-model="newMedia.linkUrl"
                    outlined
                    aria-label="url"
                    :rules="urlRules"
                    class="base-input v-text-no-shadow v-input-restrict-height"
                  />
                </div>

                <div v-else>
                  <FileDrop
                    v-if="
                      !editingMedia ||
                        (editingMedia && !editingMedia.linkFileUrl)
                    "
                    :value="newMedia.linkFile ? newMedia.linkFile.name : ''"
                    accept="mage/jpeg,image/gif,image/png,application/pdf"
                    class="mt-6"
                    @input="onLinkFileChange($event)"
                    @clear="newMedia.linkFile = null"
                  >
                    <div>
                      <span class="font-weight-bold primary--text"> Browse</span><span> or drop your pdf/image file here.</span>
                    </div>
                  </FileDrop>
                  <div
                    v-else
                    class="d-flex align-center mt-6"
                  >
                    <div class="editing-box">
                      {{ editingMedia.linkFileUrl }}
                    </div>
                    <v-btn
                      text
                      @click="editingMedia.linkFileUrl = null"
                    >
                      <v-icon class="close-button clickable ml-2">
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-space-between stripe px-6 py-3">
              <v-btn
                text
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                @click="onAdd()"
              >
                Apply
              </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import BaseLoader from "../../base/base-loader.vue"
import { quillEditor } from "vue-quill-editor"
import * as cloneDeep from "lodash.clonedeep"
import FileDrop from "../../shared/file-drop.vue"
import draggable from "vuedraggable"

import ReadonlyQuill from "../../shared/readonly-quill.vue"

const defaultMedia = {
  tags: "",
  title: "",
  subtitle: "",
  shortDescription: "",
  callToAction: "",
  imageFile: null,
  linkFile: null,
  linkUrl: ""
}

export default {
  name: "ProductFlexibleMedia",
  components: { BaseLoader, quillEditor, FileDrop, ReadonlyQuill, draggable },
  props: ["media"],
  data: () => ({
    isDialogOpen: false,
    mediaClone: [],
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"]
        ]
      }
    },
    newMedia: cloneDeep(defaultMedia),
    editingMedia: null,
    linkType: "url"
  }),
  computed: {
    isLoading () {
      return this.media.some(x => x.id === -1)
    },
    urlRules () {
      const rules = []

      const isUrl = v => {
        if (!v) {
          return true
        }
        if (
          v.match(
            /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi
          )
        ) {
          return true
        }
        return "Invalid Url"
      }
      rules.push(isUrl)
      return rules.concat(this.required)
    },
    required () {
      return [v => !!v || "Required"]
    },
    dragOptions () {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },
  watch: {
    media: {
      handler () {
        this.mediaClone = cloneDeep(this.media)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeDialog () {
      this.isDialogOpen = false
      this.newMedia = cloneDeep(defaultMedia)
      this.editingMedia = null
    },
    openDialog () {
      this.isDialogOpen = true
    },
    onOpenFileUpload () {
      this.$refs.fileUpload.click()
    },
    onImageFileChange (fileList) {
      if (fileList && fileList[0]) {
        this.newMedia.imageFile = fileList[0]
      }
    },
    onLinkFileChange (fileList) {
      if (fileList && fileList[0]) {
        this.newMedia.linkFile = fileList[0]
      }
    },
    onReorder () {
      this.$emit("reorder", this.mediaClone)
    },
    onChangeLinkType (linkType) {
      this.linkType = linkType
    },
    onAdd () {
      if (!this.$refs.form.validate()) {
        return
      }
      const clone = cloneDeep(this.newMedia)
      if (this.linkType === "url") {
        clone.linkFile = null
      } else {
        clone.linkUrl = null
      }

      const formData = new FormData()
      for (const key in clone) {
        if (clone[key]) {
          formData.append(key, clone[key])
        }
      }

      if (this.editingMedia) {
        formData.append("id", this.editingMedia.id)
        formData.append("productId", this.editingMedia.productId)
        this.$emit("editMedia", formData)
      } else {
        this.$emit("addMedia", formData)
      }
      this.closeDialog()
    },
    deleteMedia (media) {
      this.$emit("deleteMedia", media.id)
    },
    onEdit (media) {
      this.editingMedia = cloneDeep(media)
      this.newMedia = {
        ...this.newMedia,
        tags: this.editingMedia.tags,
        title: this.editingMedia.title,
        subtitle: this.editingMedia.title,
        shortDescription: this.editingMedia.shortDescription,
        callToAction: this.editingMedia.callToAction,
        linkUrl: this.editingMedia.linkUrl ?? ""
      }
      if (this.editingMedia.linkFileUrl) {
        this.linkType = "upload"
      }
      this.openDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/variables";
.field {
  &:not(:first-of-type) {
    margin-top: 24px;
  }
}

.stripe {
  background-color: $even-lighter-grey;
}

.media {
  border-top: 1px solid $light-grey;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  background-color: $white;
  position: relative;

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .handle {
    display: flex;
    align-items: center;
    cursor: move;
    justify-content: center;
    &:hover {
      background-color: $even-lighter-grey;
    }
  }
}

.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.endorsement:last-child {
  border-bottom: 1px solid $light-grey;
}

.btn {
  text-align: start;
  display: flex;
  gap: 24px;
  &:hover {
    background-color: $even-lighter-grey;
  }
  padding: 24px 0;
}

.end {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: $even-lighter-grey;
  }
}

.stripe {
  background-color: $even-lighter-grey;
}

.v-input {
  margin-bottom: -25px;
}

.ghost {
  opacity: 0;
}

.editing-box {
  flex: 1;
  border-radius: 4px;
  border: 1px solid $black;
  color: $dark-blue;
  font-weight: 900;
  min-height: 50px;
  padding: 0 24px;
  display: flex;
  align-items: center;
}
</style>
